/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends HTMLElement {
  connectedCallback() {
    if (this.hasAttribute('demote-first-level-headings')) {
      this.#demoteFirstLevelHeadings();
    }

    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  #demoteFirstLevelHeadings() {
    this.querySelectorAll('h1').forEach((heading) => {
      const replacement = document.createElement('h2');

      for (const attribute of heading.attributes) {
        replacement.setAttribute(attribute.name, attribute.value);
      }
      // AYUBA: embedded article CSS written for h1 still matches the demoted heading (see ayuba-scope-embedded-css).
      replacement.setAttribute('data-ayuba-h1', '');

      replacement.append(...heading.childNodes);
      heading.replaceWith(replacement);
    });
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    wrapper.tabIndex = 0;
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
